import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          {contactContent.title}
        </h2>
        <div className="flex flex-col md:flex-row gap-8 items-start">
          <div className="flex-1 max-w-lg">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              {contactContent.desc}
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </span>
                <span className="text-foreground-700">{contactContent.email}</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-qq-line"></i>
                </span>
                <span className="text-foreground-700">{contactContent.qq}</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-wechat-line"></i>
                </span>
                <span className="text-foreground-700">{contactContent.wechat}</span>
              </div>
            </div>
          </div>
          <div className="flex-1 bg-background-100 rounded-lg p-6 border border-background-200/70 w-full max-w-md">
            <div className="text-center">
              <span className="w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <i className="ri-chat-smile-2-line text-4xl text-secondary-500"></i>
              </span>
              <p className="text-sm text-foreground-600">期待您的来信，我们将在24小时内回复</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}